// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Statistics__statisticsDataBlock___jDYYg {
    display: grid;
    grid-template-columns: max-content auto;
    gap: 0.5rem;
}

.Statistics__statistics___lDzvZ {
    display: flex;
    gap: 3.5rem;
    align-items: flex-start;
    align-self: stretch;

    padding: 0.75rem;

    border: 0.1rem solid var(--color-bg-border);
    border-radius: 0.25rem;
}

.Statistics__statisticsHeader___LO9pG {
    margin-top: 1rem;
    margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/MapFetchingModal/Statistics/Statistics.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".statisticsDataBlock {\n    display: grid;\n    grid-template-columns: max-content auto;\n    gap: 0.5rem;\n}\n\n.statistics {\n    display: flex;\n    gap: 3.5rem;\n    align-items: flex-start;\n    align-self: stretch;\n\n    padding: 0.75rem;\n\n    border: 0.1rem solid var(--color-bg-border);\n    border-radius: 0.25rem;\n}\n\n.statisticsHeader {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statisticsDataBlock": `Statistics__statisticsDataBlock___jDYYg`,
	"statistics": `Statistics__statistics___lDzvZ`,
	"statisticsHeader": `Statistics__statisticsHeader___LO9pG`
};
export default ___CSS_LOADER_EXPORT___;
